import { Container, Stack, SxProps } from "@mui/material";
import { useSearch } from "@tanstack/react-router";
import { useEffect } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "./context";
import DemoCardManager from "./DemoCardManager";
import ResultsStep from "./sections/ResultsStep/ResultsStep";
import useDemoActionsStore from "./store";

const containerSx: SxProps = {
	height: "100vh",
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	backgroundColor: "background.neutral"
};

const stackSx: SxProps = {
	backgroundColor: "background.neutral",
	alignItems: "center",
	width: "100%"
};

// ----------------------------------------------------------------------

export type Props = {
	type: string;
};

export const DemoContainer = ({ type }: Props) => {
	const [state, actions] = useDemoActionsStore();

	const { onChangeLang, currentLang } = useLocales();
	const { locale }: { locale: string } = useSearch({
		strict: false
	});

	useEffect(() => {
		if (locale && locale !== currentLang.value) onChangeLang(locale);
	}, [locale]);

	return (
		<Context.Provider value={{ actions, state, type }}>
			{state.step !== 5 && (
				<Container
					maxWidth={false}
					sx={{ ...containerSx, height: { xs: "auto", sm: "100vh" }, pt: { xs: 2, sm: 0 } }}
				>
					<Stack sx={stackSx}>
						<DemoCardManager />
					</Stack>
				</Container>
			)}
			{state.step === 5 && <ResultsStep />}
		</Context.Provider>
	);
};

export default DemoContainer;
